var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message?.text)?_c('div',{staticClass:"tw-p-6 tw-flex",class:_vm.message.role},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.message.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }